export default __webpack_public_path__ + "static/media/StJohnsOnTenth.cdb6da6d.jpg";